// Statusni i labelski metapodaci za "Promocije" i "Refundacije" tabove
// finansija - preslikano sa
// dostavljaci-front/app/utils/{promotion,refund}.ts, prilagođeno za
// Vuetify2 boje (success/warning/error/secondary/grey).
//
// Labeli se ne čuvaju kao gotov tekst (label) vec kao i18n kljuc (labelKey),
// jer su ovo plain JS module-level konstante bez pristupa this.$t().

export const PROMOTION_STATUS_META = {
  active: { labelKey: "finance_status_promotion_active", color: "success" },
  completed: { labelKey: "finance_status_promotion_completed", color: "grey" },
  planned: { labelKey: "finance_status_promotion_planned", color: "warning" },
};

export const PROMOTION_FUNDING_META = {
  ordera: "finance_funding_ordera",
  restaurant: "finance_funding_restaurant",
  shared: "finance_funding_shared",
};

export const REFUND_STATUS_META = {
  approved: { labelKey: "finance_status_refund_approved", color: "success" },
  pending: { labelKey: "finance_status_refund_pending", color: "warning" },
  rejected: { labelKey: "finance_status_refund_rejected", color: "grey" },
};

// "Tok novca" / money_flow - dijeljeno između Transakcija taba (kolona + legenda)
// i Pregleda (rezime aktivnosti). Vidi ticket #223693 / #223694.
// Boje: crvena = restoran duguje, zelena = Ordera duguje, plava = plaćeno direktno.
export const MONEY_FLOW_META = {
  RESTAURANT_OWES_ORDERA: { color: "#d9534f", labelKey: "finance_mf_restaurant_owes" },
  ORDERA_OWES_RESTAURANT: { color: "#00b37e", labelKey: "finance_mf_ordera_owes" },
  DIRECT_PAYMENT: { color: "#2f6fed", labelKey: "finance_mf_direct_payment" },
  ORDER_VALUE: { color: "#9aa4b2", labelKey: "finance_mf_order_value" },
  // Retko - samo kad je ugovor sa firmom za dostavu podešen da restoran
  // direktno plaća naknadu dostave (odvojeno od RESTAURANT_OWES_ORDERA,
  // primalac je firma za dostavu, ne Ordera). Vidi backend izvještaj 13.09.2026.
  RESTAURANT_OWES_DELIVERY_COMPANY: {
    color: "#d9820f",
    labelKey: "finance_mf_owes_delivery_company",
  },
};

// Isti kodovi kao Knjiga salda (description) - vidi ticket #223672 v2.
// Dijeljeno između Transakcija taba (filter/kolona) i Pregleda (Nedavne
// aktivnosti) - oba prikazuju sirovi entry_type sa backenda i treba im isti
// prevod. Redoslijed ključeva određuje redoslijed opcija u filteru na
// Transakcije tabu.
export const TRANSACTION_TYPE_LABEL_KEYS = {
  ORDER_REVENUE: "finance_desc_order_revenue",
  COMMISSION: "finance_desc_commission",
  CASH_RECEIVED: "finance_desc_cash_received",
  CASH_ADVANCE: "finance_desc_cash_advance",
  PAYOUT: "finance_desc_payout",
  SUBSCRIPTION: "finance_desc_subscription",
  REFUND: "finance_desc_refund",
};

// currency defaults to "KM" only as a last-resort fallback; callers should
// pass the restaurant's configured currency (see global `restaurantCurrency` mixin in main.js).
export function formatCurrency(value, currency = "KM") {
  const num = Number(value);
  return `${Number.isFinite(num) ? num.toFixed(2) : "0.00"} ${currency}`;
}

// Lokalni (ne UTC) YYYY-MM-DD za ?from=/?to= parametre. date.toISOString() NE
// koristiti za ovo - konvertuje u UTC, pa lokalna ponoć u UTC+1/+2 zonama
// (Bosna/Srbija/Hrvatska) upadne u PRETHODNI dan (npr. 1.1. postane 31.12.).
// Vidi network checklist F13, 14.09.2026.
export function toDateParam(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("sr-RS", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
